import React from 'react';
import { Label } from '@patternfly/react-core';
import { CheckCircleIcon, ExclamationCircleIcon, HourglassHalfIcon } from '@patternfly/react-icons';
import type { OrganizationDomainStatus } from '../../../types/models';

export function renderDomainStatus(status: OrganizationDomainStatus) {
  switch (status) {
    case 'verified':
      return (
        <Label color="green" icon={<CheckCircleIcon />}>
          Verified
        </Label>
      );
    case 'pending':
      return (
        <Label color="orange" icon={<HourglassHalfIcon />}>
          Pending
        </Label>
      );
    case 'failed':
      return (
        <Label color="red" icon={<ExclamationCircleIcon />}>
          Failed
        </Label>
      );
  }
}
